<template>
  <Modal
    v-model="_value"
    width="500"
    title="HIK设置车辆信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">
      <FormItem prop="registrationNumType" label="车牌分类">
        <Select class="field" v-model="setDriverCardParams.registrationNumType" placeholder="请输入车牌分类">
          <Option v-for="item in registrationNumTypeOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="vin" label="车架号">
        <Input v-model="setDriverCardParams.vin" placeholder="请输入车架号">
        </Input>
      </FormItem>
      <FormItem prop="engineNum" label="发动机号">
        <Input v-model="setDriverCardParams.engineNum" placeholder="请输入发动机号">
        </Input>
      </FormItem>
      <FormItem prop="vehicleType" label="车辆类型">
        <Input v-model="setDriverCardParams.vehicleType" placeholder="请输入车辆类型">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'


export default {
  name: 'hiksetdrivervehicleinfomodal',
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        registrationNumType: null,
        vin: null,
        engineNum: null,
        vehicleType: null
      },
      registrationNumTypeOptions:[
        {label:'小型车辆', value: '1'},
        {label:'大型车辆', value: '2'},
        {label:'挂车', value: '3'},
      ],

    }
  },
  methods: {
    ...mapActions([
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.registrationNumType = null
        this.setDriverCardParams.vin = null
        this.setDriverCardParams.engineNum = null
        this.setDriverCardParams.vehicleType = null

        store.dispatch('PositioningDeviceInfoServ_SearchByName',{
          params:{
            name: this._terminalNumValue
          },
          urlparams:null,
        }).then(res =>{
          if (store.getters.get_PositioningDeviceInfo_SearchByNameResult && store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){
            console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult)
            let vehicleInfoId = store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].vehicleInfoId
            if (vehicleInfoId!=null){
              store.dispatch('VehicleInfoServ_GetDetail',{
                params:{
                  id: vehicleInfoId
                },
                urlparams:null
              }).then(res =>{
                if (store.getters.get_VehicleInfo_GetDetailResult){
                  let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                  this.setDriverCardParams.vin = vehicleInfo.vin
                  if (vehicleInfo.vehicleType != null){
                    this.setDriverCardParams.vehicleType = vehicleInfo.vehicleType.name
                  }
                  this.setDriverCardParams.engineNum = vehicleInfo.engineNum
                }
              }).catch(err =>{

              })

            } else {
              console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId)
              store.dispatch('InstallOrderServ_GetDetail',{
                params:{
                  id: store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId
                },
                urlparams:null
              }).then(res =>{
                if (store.getters.get_InstallOrder_GetDetailResult){
                  let installOrder = store.getters.get_InstallOrder_GetDetailResult
                  this.setDriverCardParams.vin = installOrder.tempVehicleInfo.vin
                  if (installOrder.tempVehicleInfo.vehicleType != null){
                    this.setDriverCardParams.vehicleType = installOrder.tempVehicleInfo.vehicleType.name
                  }
                  this.setDriverCardParams.engineNum = installOrder.tempVehicleInfo.engineNum
                }
              }).catch(err =>{

              })
            }
          }
        }).catch(err =>{

        })
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.registrationNumType = null
      this.setDriverCardParams.vin = null
      this.setDriverCardParams.engineNum = null
      this.setDriverCardParams.vehicleType = null
    },
    onSendDriverCardParams () {
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: 'VehInfo:' + this.setDriverCardParams.registrationNumType + ',' + this.setDriverCardParams.vin + ',' + this.setDriverCardParams.engineNum + ',' + this.setDriverCardParams.vehicleType + ';A!!!', urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
